import { render, staticRenderFns } from "./downApp.vue?vue&type=template&id=63ce3689&scoped=true&"
import script from "./downApp.vue?vue&type=script&lang=js&"
export * from "./downApp.vue?vue&type=script&lang=js&"
import style0 from "./downApp.vue?vue&type=style&index=0&id=63ce3689&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce3689",
  null
  
)

export default component.exports